import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { AppConfig } from '../../app.config';
import { BaseService } from './baseService';
import { AppInsightService } from './app-insight.service';

@Injectable()
export class AnnualReportService extends BaseService{
    constructor(protected http: HttpClient, protected config: AppConfig, protected appInsights: AppInsightService) {
        super(http, config, appInsights);
    }

   

    public getAnnualReportDetails(year:string, jurisdiction:string): Promise<AnnualReportDetails> {
        var url = '/annualreport/getDetails/'
        url += (year + '/');
        url += (jurisdiction);
        
        return this.httpget<AnnualReportDetails>(url);
    }

    public submitAnnualReport(year:string, jurisdiction:string, annualreport:AnnualReportDetails): Promise<AnnualReportDetails> {
        var url = '/annualreport/Submit';
        
        return this.httppost<AnnualReportDetails>(url, annualreport);
    }

    public uploadAnnualReportFile(file: any, annualreport:AnnualReportDetails, reportType:string): Promise<AnnualReportDetails> {
        let formData: FormData = new FormData();
            formData.append('file', file, file.name);
            formData.append('annualReportDetails', JSON.stringify(annualreport));
        var url = '/annualreport/upload/';
            url += (reportType);
        
        return this.httppost<AnnualReportDetails>(url, formData);
    }

    public downloadAnnualReportFile(year:string, jurisdiction:string, reportType:string): Promise<any> {
        let url = '/annualreport/download/'
            url += (year + '/');
            url += (jurisdiction + '/');
            url += (reportType);
        return this.httpgetblob<any>(url);
    }

    public deleteAnnualReportFile(year:string, jurisdiction:string, reportType:string): Promise<AnnualReportDetails> {
        let url = '/annualreport/delete/'
        url += (year + '/');
        url += (jurisdiction + '/');
        url += (reportType);
        
        return this.httppost<AnnualReportDetails>(url, null);
    }
}

export class AnnualReportDetails{
    public id:string;
    public Year:string;
    public Jurisdiction:string;
    public IsSubmitted:boolean;

    public ReportDetails:ReportDetail[];
}

export class ReportDetail{
    public ReportDisplayName:string;
    public ReportType:any;
    public IsRequired:boolean;
    public IsFileSubmitted:boolean;
}

